module.exports = __webpack_public_path__ + "static/media/purplerose2.5d9b7c9f.jpg";